import { forEach } from 'lodash';
import { cloneDeep } from 'gear';

// [TODO] FigureCache should use a standard Map to hold the cached data

export const FigureCache = function(compute,owner,data) {
  this._data = data || {} ;
  this._owner = owner;
  this._compute = compute;
};

export default FigureCache;

FigureCache.drop = {};
FigureCache.keep = {};

FigureCache.prototype = {
  owner( v ) {
    return v===undefined?this._owner:(this._owner=v,this);
  },

  clone( otherOwner ) {
    const data = {};
    forEach( this._data, (value,key) => { data[key] = cloneDeep(value); });
    return new FigureCache(this._compute,otherOwner,data);
  },

  has( key ) {
    return this._data[key] !== undefined ;
  },

  get( key ) {
    let value = this._data[key];
    if( value === undefined ) {
      value = this._compute[key].call(this._owner);
      this._data[key] = value;
    }
    return value;
  },

  set( key, value ) {
    this._data[key] = value ;
  },

  clear( key ) {
    if( key === undefined ) {
      this._data = {} ;
    }
    else {
      delete this._data[key] ;
    }
  },

  stash( key ) {
    const data = this._data;
    const v = data[key];
    if( v ) {
      data['stash_'+key] = v.clone();
    }
  },

  unstash( key ) {
    const data = this._data;
    const stash_key = 'stash_'+key;
    const v = data[stash_key];
    if( v ) {
      data[key] = v;
      delete data[stash_key];
    }
  },

  copy( fromKey, toKey ) {
    const data = this._data;
    const value = data[fromKey];
    if( value ) {
      data[toKey] = value.clone();
    }
    else {
      delete data[toKey] ;
    }
  },

  update( key, updater, f ) {
    const data = this._data;
    if( updater[f] ) {
      const v = data[key];
      if( v ) {
        data[key] = updater[f](v);
      }
    }
    else { // Drop it
      delete data[key];
    }
  }
};



/** WEBPACK FOOTER **
 ** ./src/cdl/figure/detail/cache.js
 **/